import { render, staticRenderFns } from "./ActualVsNeededSubmitCard.vue?vue&type=template&id=1b5ce4a6&scoped=true&"
import script from "./ActualVsNeededSubmitCard.vue?vue&type=script&lang=js&"
export * from "./ActualVsNeededSubmitCard.vue?vue&type=script&lang=js&"
import style0 from "./ActualVsNeededSubmitCard.vue?vue&type=style&index=0&id=1b5ce4a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5ce4a6",
  null
  
)

export default component.exports